import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { Qualification } from 'shell/models/qualification';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface ListQualificationProps {
  disabled: boolean;
  value: string;
  required?: boolean;
  onChange: (event: SelectChangeEvent<string>) => void;
  errorSelect?: boolean;
}

const ListQualification = ({
  disabled,
  onChange,
  value,
  required,
  errorSelect = false,
}: ListQualificationProps): React.ReactElement => {
  const {
    data,
    error,
    get: getListQualifications,
  } = useHttpFetch<HttpResponseList<Qualification>>(`${__MANAGEMENT_API_URL__}/qualifiche`, {
    data: {
      payload: {
        list: [],
      },
    },
  });

  const qualifications: Array<ItemVM> = useMemo(() => {
    if (!!error || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((qualification) => ({
      id: qualification.key?.codiceQualifica,
      value: qualification.descrizione,
    }));
  }, [data, error]);

  useEffect(() => {
    getListQualifications();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={errorSelect} id="type-label">
        {required ? 'Qualifica *' : 'Qualifica'}
      </InputLabel>
      <PmiSelect
        labelId="qualification-label"
        id="qualification"
        name="qualification"
        value={value}
        label={required ? 'Qualifica *' : 'Qualifica'}
        onChange={onChange}
        disabled={disabled}
        error={errorSelect}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {qualifications
          .sort((a, b) => a.value?.localeCompare(b.value))
          .map((qualification: ItemVM) => (
            <MenuItem key={qualification.id} value={qualification.id}>
              {qualification.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListQualification.displayName = 'List qualification component';

const MemoizedListQualification = memo(ListQualification);

export default MemoizedListQualification as typeof ListQualification;
